<template>
    <div class="uik-top-bar-section__wrapper">
        <slot></slot>
    </div>
</template>

<script>
export default {
    name: "UikTopBarSection"
}
</script>

<style lang="scss">
.uik-top-bar-section__wrapper {
  display: flex;
  align-items: center;
  padding: 0 30px;
  .uik-divider__vertical {
    min-height: 70px;
    @media only #{$mediaMobile} {
      min-height: 56px;
    }
    @media only screen and (max-width: 500px) {
      margin: 0 15px 0 25px;
    }
  }
  @media only #{$mediaMobile} {
    padding: 0 20px;
  }
  @media only screen and (max-width: 500px) {
    padding: 0 13px;
  }
}
</style>
